export default {
// 获取分类label值
  getCascaderObj(val, opt) {
    return val.map(function (value, index, array) {
      for (var itm of opt) {
        if (itm.id == value) {
          opt = itm.children;
          return itm.name;
        }
      }
      return null;
    })
  },
  // 数组对象合并去重
  removingDplicate(a, b) {
    let ab = a.concat(b);
    let obj = {};
    let result = ab.reduce((cur,next) => {
      obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
      return cur;
    },[]); //设置cur默认类型为数组，并且初始值为空的数组
    console.log(result);
    return  result;
  },

  /* 合法uri*/
  validateURL(textval) {
    const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return urlregex.test(textval)
  },

  /* 小写字母*/
  validateLowerCase(str) {
    const reg = /^[a-z]+$/
    return reg.test(str)
  },

  /* 大写字母*/
  validateUpperCase(str) {
    const reg = /^[A-Z]+$/
    return reg.test(str)
  },

  /* 大小写字母*/
  validatAlphabets(str) {
    const reg = /^[A-Za-z]+$/
    return reg.test(str)
  }
}




// WEBPACK FOOTER //
// ./src/utils/validate.js